export const createInivisbleIframe = (containerId: string) => {
  const existingContainer = document.querySelector(containerId);
  if (existingContainer) {
    existingContainer.remove();
  }

  const container = document.createElement("div");
  container.id = containerId.split("#")[1];

  container.style.position = "fixed";
  container.style.left = "-9999px";
  container.style.top = "-9999px";
  container.style.width = "1px";
  container.style.height = "1px";
  container.style.overflow = "hidden";
  container.style.opacity = "0";
  container.style.pointerEvents = "none";
  container.style.zIndex = "-1";

  document.body.appendChild(container);
};
